const CART_ITEM_STOCK_TYPES = {
    DEFAULT_SUPPLIER: 1,
    MPS_STOCK: 2,
    FIXED_STOCK: 3,
    MIXED_STOCK: 4
};

export default CART_ITEM_STOCK_TYPES;
